import moment from 'moment';

import { dateFormat } from '../../../../../../../contrib/utils';
import { today } from '../../../../../../../Utils/today';

export const isSeasonCompleted = (endDate: string): boolean => {
  return moment(endDate, dateFormat).isBefore(today);
};
